import type { FieldValues } from "react-hook-form";

export const getChangedFormFields = <T extends FieldValues>(
    allFields: T,
    dirtyFields: Partial<Record<keyof T, boolean>>,
): Partial<T> =>
    Object.keys(dirtyFields).reduce(
        (acc, currentField) => ({
            ...acc,
            [currentField]: allFields[currentField],
        }),
        {} as Partial<T>,
    );

export const getChangedFormFieldsDeep = <T extends FieldValues>(
    allFields: T,
    dirtyFields: Partial<Record<keyof T, boolean | Record<string, boolean>>>,
): Partial<T> =>
    Object.keys(dirtyFields).reduce((acc, currentField) => {
        if (typeof dirtyFields[currentField] === "boolean") {
            return {
                ...acc,
                [currentField]: allFields[currentField],
            };
        } else {
            return {
                ...acc,
                [currentField]: getChangedFormFieldsDeep(
                    allFields[currentField],
                    dirtyFields[currentField] as Partial<FieldValues>,
                ),
            };
        }
    }, {} as Partial<T>);

export const getFormFieldsWithValues = <T extends FieldValues>(allFields: T): Partial<T> =>
    Object.keys(allFields).reduce((acc, currentField) => {
        if (typeof allFields[currentField] === "object") {
            return {
                ...acc,
                [currentField]: getFormFieldsWithValues(allFields[currentField]),
            };
        } else if (allFields[currentField] === '') {
            return acc         
        } else if (allFields[currentField] === undefined) {
            return acc  
        } else {
            return {
                ...acc,
                [currentField]: allFields[currentField],
            }
        }
    }, {} as Partial<T>);
